import React from 'react'
import styled from 'react-emotion'


const quote = require('../assets/quote.svg')

const CardContainer = styled.div`
  box-shadow: 2px 2px 10px rgba(0, 0, 0, .3);
  border-radius: 8px;
  display: inline-block;
  padding: 3em;
  margin: 0.2em 0 1.5em;
  width: 100%;
  -webkit-transition:1s ease all;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  background-color: white;
`

const CardDesc = styled.p`
  font-style: italic;
  white-space: pre-line;
`

const QuoteImg = styled.img`
  float: right;
  margin-left: 1em;
`

const Card = (props) => {
  const { item } = props
  return (
    <CardContainer>
      <QuoteImg src={quote} />
      <h3>{item.partner}</h3>
      <CardDesc dangerouslySetInnerHTML={{ __html: item.description }} />
      <div>{item.author}</div>
    </CardContainer>
  )
}
 
export default Card;


// WEBPACK FOOTER //
// ./src/components/card.js